import React from 'react';
import PropTypes from 'prop-types';
import './_MatchDetailPlayersTeamSwitch.scss';

const BUTTON_ID_PREFIX = 'match-detail-switch-btn';
const getButtonId = (index) => `${BUTTON_ID_PREFIX}-${index}`;

const focusButton = (index) => {
  const target = document.getElementById(getButtonId(index));
  if (!target) return;
  if (window.SpatialNavigation && typeof window.SpatialNavigation.focus === 'function') {
    window.SpatialNavigation.focus(`#${getButtonId(index)}`);
    return;
  }
  target.focus();
};

const MatchDetailPlayersTeamSwitch = ({ teams, selectedTeamId, onChange }) => {
  if (!teams || !teams.length) return null;

  const handleKeyDown = (e, index) => {
    const isUp = e.key === 'ArrowUp' || e.keyCode === 38;
    const isLeft = e.key === 'ArrowLeft' || e.keyCode === 37;
    const isRight = e.key === 'ArrowRight' || e.keyCode === 39;

    if (!isUp && !isLeft && !isRight) return;

    e.preventDefault();
    e.stopPropagation();

    if (isUp) {
      const targetSelector = '#match-detail-tab-players';
      const target = document.querySelector(targetSelector);
      if (!target) return;
      if (window.SpatialNavigation && typeof window.SpatialNavigation.makeFocusable === 'function') {
        window.SpatialNavigation.makeFocusable();
      }
      if (window.SpatialNavigation && typeof window.SpatialNavigation.focus === 'function') {
        window.SpatialNavigation.focus(targetSelector);
        return;
      }
      target.focus();
      return;
    }

    if (isLeft) {
      const prevIndex = index > 0 ? index - 1 : teams.length - 1;
      focusButton(prevIndex);
      return;
    }

    if (isRight) {
      const nextIndex = index < teams.length - 1 ? index + 1 : 0;
      focusButton(nextIndex);
    }
  };

  return (
    <div className="match-detail-players-switch">
      {teams.map((team, index) => {
        const teamId = team && team.id ? team.id : `team-${index + 1}`;
        const isActive = teamId === selectedTeamId;
        const prevIndex = index > 0 ? index - 1 : teams.length - 1;
        const nextIndex = index < teams.length - 1 ? index + 1 : 0;

        return (
          <a
            key={getButtonId(index)}
            id={getButtonId(index)}
            href="#"
            className={`focusable match-detail-players-switch__button ${isActive ? 'match-detail-players-switch__button--active' : ''}`}
            data-sn-up="#match-detail-tab-players"
            data-sn-left={`#${getButtonId(prevIndex)}`}
            data-sn-right={`#${getButtonId(nextIndex)}`}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onFocus={() => onChange(teamId)}
            onClick={(e) => {
              e.preventDefault();
              focusButton(index);
              onChange(teamId);
            }}
          >
            {team.label}
          </a>
        );
      })}
    </div>
  );
};

MatchDetailPlayersTeamSwitch.propTypes = {
  teams: PropTypes.array,
  selectedTeamId: PropTypes.string,
  onChange: PropTypes.func
};

MatchDetailPlayersTeamSwitch.defaultProps = {
  teams: [],
  selectedTeamId: '',
  onChange: () => {}
};

export default MatchDetailPlayersTeamSwitch;



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/FootballMatchDetail/Components/MatchDetailPlayersTeamSwitch/MatchDetailPlayersTeamSwitch.jsx